import React from "react";
import { AccordionList, Accordion } from 'onefaceui-react-components';

import AdditionalMaterials from "./AdditionalMaterials";
import HolderMaterials from "./HolderMaterials";
import { getResourceTo } from "react/utils/utils";

function AdditionalMaterialTab({ addMatArray, holdMatArray, i18n, renderNoResultsFound }) {
  return (
    <div id="additionalMaterialContainer">
      <AccordionList size="md">
        <Accordion dataTestId="additionalMaterial" label={getResourceTo('route.data.additionalMaterial')}>
          {addMatArray
            ? <AdditionalMaterials
              addMatArray={addMatArray}
              i18n={i18n}
            />
            : renderNoResultsFound()}
        </Accordion>

        <Accordion dataTestId="holderMaterial" label={getResourceTo('route.data.holderMaterial')}>
          {holdMatArray
            ? <HolderMaterials
              holdMatArray={holdMatArray}
              i18n={i18n}
            />
            : renderNoResultsFound()}
        </Accordion>
      </AccordionList>
    </div>
  );
}

export default AdditionalMaterialTab;
